// extracted by mini-css-extract-plugin
export default {"text":"TitleAdditional_text__ciX0m"};